import createReducer from "./createReducer";

import { QA_REPORT_ACTIONS } from "./actions/QA";
import { QATerritories, SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";


const initialQAReportStore = {
	items:[],
	page: 1,
	rpp: 25,
	totalItems: 0,
	totalPages: 0,
	hasErrorLoading: false,
	isLoaded: false,
};

const actionCreators = {
	loadQAReport,
	clearQAReport,
};

const handlers = {
	[QA_REPORT_ACTIONS.FETCH_QA_REPORT]: isLoadingReport,
	[QA_REPORT_ACTIONS.FETCH_QA_REPORT_SUCCESS]: initQAReport,
	[QA_REPORT_ACTIONS.FETCH_QA_REPORT_ERROR]: errorQAReport,
	[QA_REPORT_ACTIONS.RESET_QA_REPORT]: clearList,
};

let reducerConfig = {
	typeRoot: "QA_REPORT_ACTIONS",
	initialState: initialQAReportStore,
	actionTypes: QA_REPORT_ACTIONS,
	actionCreators,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "dateStart:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {
	dateStart: {
		name: "dateStart",
		type: "Date",
		displayName: "Date Start",
	},
	dateEnd: {
		name: "dateEnd",
		type: "Date",
		displayName: "Date End",
	},
	submittedLibraries: {
		name: "submittedLibraries",
		type: "Number",
		displayName: "Libraries with Creatives Submitted",
	},
	location: {
		name: "location",
		type: "String",
		displayName: "Department",
	},
});

export function loadQAReport(group="week") {
	const limitOptions = { week: 12, month: 18 }
		, limit = limitOptions[group];

	return (dispatch, getState) => {
		const state = getState();
		const filterInfo = state?.qaReports?.filterInfo;

		return dispatch({
			type: QA_REPORT_ACTIONS.FETCH_QA_REPORT,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url:`ui/creative-libraries/studio-panel-report-generic?group=${group}&limit=${limit}`,
				params: filterInfo,
				success: QA_REPORT_ACTIONS.FETCH_QA_REPORT_SUCCESS,
				error: QA_REPORT_ACTIONS.FETCH_QA_REPORT_ERROR,
			},
		});
	};
}

export function clearQAReport(){
	return (dispatch) => {
		dispatch({
			type: QA_REPORT_ACTIONS.RESET_QA_REPORT,
		});

		return Promise.resolve({ success: true });
	};
}

function isLoadingReport(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function initQAReport(state, action){
	let { items } = action.payload.data || {}
		, reportData = items.map((item) => {
			let location;

			if(item.location === 0){
				location = { label: "All", value: 0 };
			}else {
				location = QATerritories.find(v => v.value === item.location);
			}

			return {
				...item,
				location,
			};
		});

	return {
		...state,
		...action.payload.data,
		items: reportData,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function errorQAReport(state, action){
	return {
		...state,
		items: [],
		isLoaded: true,
		hasErrorLoading: true,
	};
}

function clearList(state, action) {
	return {
		...initialQAReportStore,
		filterInfo: state.filterInfo,
		columnFilters: state.columnFilters,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const Report = reducerConfig.actionCreators;
export const PRIVATE = {
	...reducerConfig.handlers,
};
